var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoomWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 188.832 188.832",
    style: {
      enableBackground: "new 0 0 188.832 188.832"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M174.936,7.5v173.832c0,4.142-3.357,7.5-7.5,7.5h-17.049c-4.143,0-7.5-3.358-7.5-7.5V32.048H71.375  l48.963,12.193c3.342,0.833,5.688,3.834,5.688,7.278v113.813c0,3.576-2.524,6.654-6.03,7.354l-80.014,15.986  c-0.019,0.004-0.038,0.008-0.057,0.011l-0.01,0.002c-0.044,0.009-0.088,0.012-0.131,0.02c-0.196,0.035-0.393,0.069-0.593,0.088  c-0.249,0.025-0.497,0.038-0.745,0.038H21.396c-4.143,0-7.5-3.358-7.5-7.5V7.5c0-4.142,3.357-7.5,7.5-7.5h146.04  C171.579,0,174.936,3.358,174.936,7.5z",
    "data-original": "#000001",
    className: "active-path",
    "data-old_color": "#000001",
    fill: "#FFFFFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomWhite);
export default __webpack_public_path__ + "static/media/room_white.0ce10598b23bff5ae842258d07804382.svg";
export { ForwardRef as ReactComponent };